// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"47":"panel-profile","265":"panel-campaigns","405":"panel-payments","591":"panel-comissions"}[chunkId] + "." + {"47":"7cab02e2","265":"06e99ebc","405":"06e99ebc","591":"06e99ebc"}[chunkId] + ".css";
};